module.exports = __webpack_public_path__ + "images/d4e6049468dd783221931586e9804843.webp";